import { Facebook, Instagram, ShoppingBag } from "lucide-react";
import { Separator } from "./ui/separator";

const SOCIALS = [
  { icon: Facebook, href: "https://www.facebook.com/derekfeeauthor", label: "Facebook" },
  { icon: Instagram, href: "https://www.instagram.com/derekfeeauthor", label: "Instagram" },
  { icon: ShoppingBag, href: "https://www.amazon.com/stores/Derek-Fee/author/B001K87YMI", label: "Amazon" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="py-12">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <Separator className="bg-white/10 mb-12" />
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div>
            <p className="font-display text-xl font-bold text-white">Derek Fee</p>
            <p className="text-zinc-600 text-sm mt-1">&copy; 2026 All rights reserved. Irish crime thriller author.</p>
          </div>
          <div className="flex items-center gap-6">
            {SOCIALS.map(s => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-${s.label.toLowerCase()}`}
                className="text-zinc-500 hover:text-rose-700 transition-colors"
              >
                <s.icon className="h-5 w-5" />
              </a>
            ))}
          </div>
          <a
            href="/admin"
            data-testid="footer-admin-link"
            className="text-zinc-700 hover:text-zinc-500 text-xs uppercase tracking-widest transition-colors"
          >
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
